export enum EGlobalCookieKey {
  token = 'app_token',
  wide_token = 'wide_token',
  userInfo = 'user_info',
  encrypt_key = 'encrypt_key',
  userLanguage = 'i18next',
  region = 'region'
}
